import { Modal } from "antd";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../context";
import { useTranslation } from "react-i18next";
import { REGEX, SHOW_TOAST, STRINGS } from "../../constants";
import { updateUserProfile } from "../../api";
import AppButton from "../button/AppButton";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { IMAGES } from "../../assets";
import { FILE_URL } from "../../constants/Constants";
import PropTypes from "prop-types";

const EditProfile = ({ editPopup, setEditPopup }) => {
  EditProfile.propTypes = {
    editPopup: PropTypes.bool,
    setEditPopup: PropTypes.bool,
  };
  const [pickerResponse, setPickerResponse] = useState("");
  const { setProfile, profile } = useContext(AuthContext);
  const { t } = useTranslation();

  const createBlob = (imageSrc) => {
    return fetch(imageSrc)
      .then((response) => response.blob())
      .then((blob) => {
        return blob;
      });
  };

  const validationSchema = Yup.object({
    emailId: Yup.string()
      .matches(REGEX.emailRegex, t(STRINGS?.please_enter_valid_email))
      .required(t(STRINGS?.please_enter_email)),
    phoneNumber: Yup.string()
      .matches(/^\d+$/, t(STRINGS?.phone_number_must_digits))
      .max(10, t(STRINGS?.phone_number_ten_digits))
      .required(t(STRINGS?.please_enter_mobile_number)),
    name: Yup.string()
      .min(2, t(STRINGS?.enter_atleast_two_char))
      .required(t(STRINGS?.please_enter_name)),
  });

  const onSubmit = (value) => {
    updateProfile(value.name, value.phoneNumber, value.emailId);
  };
  async function updateProfile(name, mobileNumber, emailId) {
    let photo = "";

    if (pickerResponse != "") {
      photo = {
        uri: pickerResponse,
        type: "image/jpeg",
        name: pickerResponse?.name,
      };
    } else {
      photo = pickerResponse;
    }

    const formData = new FormData();
    formData.append("fullName", name);
    if (photo != "") {
      formData.append("userImage", pickerResponse);
    }
    formData.append("mobileNo", mobileNumber);
    const result = await updateUserProfile(formData, profile?._id);
    if (result?.status) {
      setProfile(result?.data?.body?.userDetail);
      SHOW_TOAST(t(STRINGS?.profile_updated), "success");
      setEditPopup(false);
    } else {
      SHOW_TOAST(t(STRINGS?.something_went_wrong), "error");
    }
  }

  const getImageSrc = () => {
    if (profile?.userImage === "" && !pickerResponse) {
      return IMAGES?.placeholder;
    } else if (pickerResponse) {
      return URL.createObjectURL(pickerResponse);
    } else {
      return `${FILE_URL}${profile?.userImage}`;
    }
  };
  const imageSrc = getImageSrc();

  return (
    <div>
      <Modal
        width={400}
        open={editPopup}
        onOk={() => setEditPopup(false)}
        onCancel={() => setEditPopup(false)}
        destroyOnClose
        centered
        footer={null}
      >
        <div>
          <h2 className="text-base font-medium text-center">
            {" "}
            {t(STRINGS.edit_profile)}
          </h2>
          <div className="mt-2">
            <div className="flex items-center justify-center">
              <div className="h-16 w-16 rounded-full bg-slate-300 flex items-center justify-center text-center outline-none">
                <img
                  src={imageSrc}
                  alt="profile"
                  className="w-full h-full object-fill outline-none rounded-full"
                />
              </div>
            </div>
            <div className="flex items-center justify-center mt-3">
              <label
                className="cursor pointer px-4 py-2 border rounded-2xl text-sm text-center"
                htmlFor="image"
              >
                {t(STRINGS.change_image)}{" "}
              </label>
              <input
                onChange={(e) => {
                  createBlob(e.target.files[0]);
                  setPickerResponse(e.target.files[0]);
                }}
                className="hidden cursor-pointer"
                id="image"
                type="file"
                accept="image/*"
              />
            </div>
          </div>
          <div>
            <Formik
              initialValues={{
                name: profile?.fullName ?? "",
                emailId: profile?.emailId ?? "",
                phoneNumber: profile?.mobileNo?.toString() ?? "",
              }}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              <Form className="py-4">
                <div className="mb-4">
                  <label>{t(STRINGS.name)}</label>
                  <Field
                    type="text"
                    id="name"
                    name="name"
                    placeholder={t(STRINGS.name)}
                    className="w-full px-2 py-2 rounded-[8px] text-sm font-normal bg-[#EDE7F557] outline-none"
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-red-500 formik-error text-sm"
                  />
                </div>
                <div className="mb-4">
                  <label> {t(STRINGS.email_ID)}</label>
                  <Field
                    disabled
                    type="email"
                    id="eamilId"
                    name="emailId"
                    placeholder={t(STRINGS.email_ID)}
                    className="w-full px-2 py-2 rounded-[8px] text-sm font-normal bg-[#EDE7F557] outline-none"
                  />
                  <ErrorMessage
                    name="emailId"
                    component="div"
                    className="text-red-500 formik-error text-sm"
                  />
                </div>
                <div className="mb-4">
                  <label>{t(STRINGS.mobile_number)}</label>
                  <Field
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                    placeholder={t(STRINGS.mobile_number)}
                    className="w-full px-2 py-2 rounded-[8px] text-sm font-normal bg-[#EDE7F557] outline-none"
                  />
                  <ErrorMessage
                    name="phoneNumber"
                    component="div"
                    className="text-red-500 formik-error text-sm"
                  />
                </div>

                <div className="flex items-center justify-center gap-2">
                  <AppButton
                    onClick={() => {
                      setEditPopup(false);
                      setPickerResponse("");
                    }}
                    btnText={t(STRINGS.cancel)}
                    disabled={false}
                    className="border  w-full py-2 mt-4 rounded-2xl"
                    btnType={"button"}
                  />
                  <AppButton
                    btnText={t(STRINGS.save)}
                    disabled={false}
                    className="bg-[#FE6B01] text-white w-full py-2 mt-4 rounded-2xl"
                    btnType={"Submit"}
                  />
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditProfile;
